import { FormElementThemeColor, StyledFormElements, formElementThemes } from '@tmh-website/ui/FormElements';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';

const arrowSVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%FILL%"><path d="m12 14.106-5.276-5.308a1.004 1.004 0 0 0 -1.427 0 1.02 1.02 0 0 0 0 1.436l5.94 5.974c.21.21.49.306.765.292a.999.999 0 0 0 .764-.292l5.94-5.974a1.02 1.02 0 0 0 0-1.436 1.004 1.004 0 0 0 -1.426 0z" /></svg>';

interface MultiselectButtonProps {
  as: string;
  $themeColor: FormElementThemeColor;
  $hideValue?: boolean;
}

export const MultiselectButton = styled(StyledFormElements.Input)<MultiselectButtonProps>`
  display: flex;
  align-items: center;
  padding-right: 40px;
  appearance: none;
  color: ${props => !props.disabled && props.theme.color[formElementThemes[props.$themeColor].text]};
  text-align: left;
  cursor: pointer;
  background-image: ${props =>
    `url("data:image/svg+xml,${encodeURIComponent(
      arrowSVG.replace(
        '%FILL%',
        transparentize(props.disabled ? 0.6 : 0, props.theme.color[formElementThemes[props.$themeColor].text])
      )
    )}")`} !important;
  background-repeat: no-repeat !important;
  background-position: right 12px center !important;
  background-size: auto 20px !important;

  ${props =>
    props.$hideValue &&
    css`
      color: transparent !important;
    `};
`;

export const FakeValue = styled.span<{ $themeColor: FormElementThemeColor; $isPlaceholder: boolean }>`
  display: block;
  flex-grow: 1;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${props =>
    props.$isPlaceholder &&
    css`
      color: ${transparentize(0.6, props.theme.color[formElementThemes[props.$themeColor].text])};
    `};
`;

interface NumberProps {
  $themeColor: FormElementThemeColor;
  $isVisible: boolean;
}

export const Number = styled.span<NumberProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0;
  min-width: 0;
  height: 24px;
  padding: 0;
  margin: -12px 8px 0 auto;
  font-size: 13px;
  font-weight: ${props => props.theme.fontWeight.semibold};
  line-height: 1;
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].checked.text]};
  text-align: center;
  background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].checked.normal]};
  border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '99999px')};
  opacity: 0;
  transition: min-width ${props => props.theme.transitionTiming} 0.25s, opacity ${props => props.theme.transitionTiming},
    margin ${props => props.theme.transitionTiming} 0.25s;
  ${props =>
    props.$isVisible &&
    css`
      min-width: 24px;
      opacity: 1;
      margin-right: 0;
      transition: min-width ${props => props.theme.transitionTiming},
        opacity ${props => props.theme.transitionTiming} 0.25s, margin ${props => props.theme.transitionTiming};
    `}
`;
